import Alpine from 'alpinejs';
import { initIcons } from './utils/icons';
import "./lightgallery.js";
import { initCookieConsent } from './utils/cookie-consent';

// Lucide icons
initIcons();

// Components

// Global
window.Alpine = Alpine;

// Inits
Alpine.start();

initCookieConsent();